export default __webpack_public_path__ + "static/GT-America-Standard-Regular-6a18c26e5c187321c836ce8ee0f9c7f9.woff";